export class TokenResponse {
  id: string;
  salt: string;
  answer: string;
}
